import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const AssetManagement = lazy(() => import("@/pages/AssetManagement/AssetManagement"));
const AssetGroup = lazy(() => import("@/pages/AssetManagement/subs/AssetGroup/AssetGroup"));
const AssetType = lazy(() => import("@/pages/AssetManagement/subs/AssetType/AssetType"));
const AssetLocation = lazy(() => import("@/pages/AssetManagement/subs/AssetLocation/AssetLocation"));

const ItemMaster = lazy(() => import("@/pages/AssetManagement/subs/AssetItems/ItemMaster"));
const AssetItems = lazy(() => import("@/pages/AssetManagement/subs/AssetItems/AssetItems"));
const BulkUploadItem = lazy(() => import("@/pages/AssetManagement/subs/AssetItems/BulkUploadItem"));
const BulkUploadReport = lazy(() => import("@/pages/AssetManagement/subs/AssetItems/BulkUploadReport"));
const ViewReport = lazy(() => import("@/pages/AssetManagement/subs/AssetItems/ItemReport"));

const AssetManagementRoute: RouteConfig = {
    path: "assets",
    element: <AssetManagement />,
    pageName: "Asset Settings",
    sidebar: {
        show: true,
        icon: "",
    },
    permission: ["ManageGroups", "ManageTypes", "ManageLocations", "ManageItems"],
    children: {
        ASSET_GROUP: {
            path: "groups",
            element: <AssetGroup />,
            pageName: "Asset Group",
            sidebar: {
                show: true,
                icon: "",
            },
            permission: ["ManageGroups"],
        },
        ASSET_TYPE: {
            path: "types",
            element: <AssetType />,
            pageName: "Asset Type",
            sidebar: {
                show: true,
                icon: "",
            },
            permission: ["ManageTypes"],
        },
        ASSET_LOCATION: {
            path: "locations",
            element: <AssetLocation />,
            pageName: "Asset Location",
            sidebar: {
                show: true,
                icon: "",
            },
            permission: ["ManageLocations"],
        },
        ASSET_ITEMS: {
            path: "items",
            element: <ItemMaster />,
            pageName: "Asset Items",
            sidebar: {
                show: true,
                icon: "",
            },
            permission: ["ManageItems"],
            children: {
                MAIN: {
                    path: "",
                    element: <AssetItems />,
                    pageName: "Asset Items",
                    sidebar: {
                        show: false,
                        icon: "",
                    },
                },
                BULK_UPLOAD: {
                    path: "bulk-upload",
                    element: <BulkUploadItem />,
                    pageName: "Asset Items",
                    sidebar: {
                        show: false,
                        icon: "",
                    },
                },
                BULK_REPORTS: {
                    path: "bulk-report",
                    element: <BulkUploadReport />,
                    pageName: "Asset Items",
                    sidebar: {
                        show: false,
                        icon: "",
                    },
                },
                VIEW_REPORTS: {
                    path: "view-report/:id",
                    element: <ViewReport />,
                    pageName: "Asset Items",
                    sidebar: {
                        show: false,
                        icon: "",
                    },
                }
            }
        },
    }
};

export default AssetManagementRoute;